module.exports = __webpack_public_path__ + "static/img/1901_5.f99c695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_5.jpg
// module id = 9a15
// module chunks = 1